import { render, staticRenderFns } from "./index1-6.vue?vue&type=template&id=dcd24d16&scoped=true&"
import script from "./index1-6.vue?vue&type=script&lang=js&"
export * from "./index1-6.vue?vue&type=script&lang=js&"
import style0 from "./index1-6.vue?vue&type=style&index=0&id=dcd24d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd24d16",
  null
  
)

export default component.exports